import { Routes } from '@angular/router';
import { MedicalConsultationsComponent } from './pages/medical-consultations/medical-consultations.component';
import { MedicalConsultationsDetailsComponent } from './pages/medical-consultations-details/medical-consultations-details.component';
import { MedicalConsultationsAppointmentsComponent } from './pages/medical-consultations-appointments/medical-consultations-appointments.component';
import { LoginComponent } from './pages/login/login.component';
import { AppointmentHandlerComponent } from './pages/appointment-handler/appointment-handler.component';
import { authGuard } from './config/guard/auth.guard';
import { AssistanceServiceComponent } from './pages/assistance-service/assistance-service.component';
import { AssistanceFormComponent } from './components/assistance-form/assistance-form.component';
import { SymptomAssessmentComponent } from './pages/symptom-assessment/symptom-assessment.component';
import { SymptomDetailsComponent } from './components/symptom-details/symptom-details.component';
import { ActivationComponent } from './pages/activation/activation.component';
import { RegistrationComponent } from './pages/registration/registration.component';
import { HealthFolderComponent } from './pages/health-folder/health-folder.component';
import { MedicalDataComponent } from './components/medical-data/medical-data.component';
import { MedicalHistoryComponent } from './components/medical-history/medical-history.component';
import { MisurationComponent } from './components/misuration/misuration.component';
import { ReportsPageComponent } from './components/reports-page/reports-page.component';
import { LandingPageComponent } from './pages/landing-page/landing-page.component';
import { PersonalAreaComponent } from './pages/personal-area/personal-area.component';
import { YourDataComponent } from './components/your-data/your-data.component';
import { ProfileManagementComponent } from './components/profile-management/profile-management.component';
import { InvoicesMethodsPaymentComponent } from './components/invoices-methods-payment/invoices-methods-payment.component';
import { HomepageComponent } from './pages/homepage/homepage/homepage.component';
import { DiscoverPathwayComponent } from './components/discover-pathway/discover-pathway.component';
import { TermsComponent } from './components/terms/terms.component';
import { TermsActivationComponent } from './components/terms-activation/terms-activation.component';
import { DigitalCardComponent } from './components/digital-card/digital-card.component';
import { LoginUpdateProfileComponent } from './pages/login-update-profile/login-update-profile.component';
import { MedicalRecordRecapComponent } from './pages/medical-record-recap/medical-record-recap.component';
import { WhoWeAreComponent } from './pages/who-we-are/who-we-are.component';
import { FaqComponent } from './pages/faq/faq.component';
import { TermsOfUseComponent } from './pages/terms-of-use/terms-of-use.component';
import { SsoPageComponent } from './components/sso-page/sso-page/sso-page.component';
import { MaintenanceComponent } from './components/maintenance/maintenance/maintenance.component';
import { MaintenanceGuard } from './config/guard/maintenance.guard';

export const routes: Routes = [
   {
    path: 'maintenance',
    component: MaintenanceComponent
  },
  {
    path: '',
    children: [
      { path: '', pathMatch: 'full', component: HomepageComponent, canActivate: [MaintenanceGuard, authGuard] },
      { path: 'sso', component: SsoPageComponent},
      { path: 'landing-page', component: LandingPageComponent, canActivate: [MaintenanceGuard] },
      { path: 'preview-page/:bpCode', component: HomepageComponent },
      { path: 'logout', component: LoginComponent },
      {
        path: 'login',
        canActivate: [MaintenanceGuard],
        children: [
          {
            path: '',
            component: LoginComponent,
          },
          {
            path: 'update-profile',
            component: LoginUpdateProfileComponent,
          },
        ],
      },
      { path: 'activation', component: ActivationComponent, canActivate: [MaintenanceGuard] },
      // { path: 'registration', component: RegistrationComponent },
      { path: 'terms-evaluation', component: TermsComponent },
      { path: 'terms-activation', component: TermsActivationComponent },
      { path: 'digitalcard', component: DigitalCardComponent },
      {
        path: 'home',
        component: HomepageComponent,
        canActivate: [MaintenanceGuard, authGuard],
        canActivateChild: [authGuard],
      },
      {
        path: 'medical-consultations',
        canActivate: [authGuard],
        canActivateChild: [authGuard],
        children: [
          {
            path: '',
            component: MedicalConsultationsComponent,
          },
          {
            path: 'appointments-detail/:id',
            component: MedicalConsultationsDetailsComponent,
          },
          {
            path: 'appointments-history',
            component: MedicalConsultationsAppointmentsComponent,
          },
          {
            path: 'specialist-consultation',
            children: [
              { path: '', component: AppointmentHandlerComponent },
              { path: 'modify', component: AppointmentHandlerComponent },
            ],
          },
          {
            path: 'showcase-discover-care-pathway',
            component: DiscoverPathwayComponent,
          },
          {
            path: 'care-pathway',
            children: [
              { path: '', component: AppointmentHandlerComponent },
              { path: 'modify', component: AppointmentHandlerComponent },
            ],
          },
          {
            path: 'discover-care-pathway',
            children: [
              { path: '', component: AppointmentHandlerComponent },
              { path: 'modify', component: AppointmentHandlerComponent },
            ],
          },
          {
            path: 'televisit-generic-booking',
            children: [
              { path: '', component: AppointmentHandlerComponent },
              { path: 'modify', component: AppointmentHandlerComponent },
            ],
          },
          {
            path: 'televisit-specialist-booking',
            children: [
              { path: '', component: AppointmentHandlerComponent },
              { path: 'modify', component: AppointmentHandlerComponent },
            ],
          },
          {
            path: 'vet-consultation',
            children: [
              { path: '', component: AppointmentHandlerComponent },
              { path: 'modify', component: AppointmentHandlerComponent },
            ],
          },
          {
            path: 'care-manager',
            children: [
              { path: '', component: AppointmentHandlerComponent },
              { path: 'modify', component: AppointmentHandlerComponent },
            ],
          },
          {
            path: 'generic-consultation',
            children: [
              { path: '', component: AppointmentHandlerComponent },
              { path: 'modify', component: AppointmentHandlerComponent },
            ],
          },
          {
            path: 'psyco-pathway',
            children: [
              { path: '', component: AppointmentHandlerComponent },
              { path: 'modify', component: AppointmentHandlerComponent },
            ],
          },
          {
            path: 'nut-pathway',
            children: [
              { path: '', component: AppointmentHandlerComponent },
              { path: 'modify', component: AppointmentHandlerComponent },
            ],
          },
          {
            path: 'first-psyco-pathway',
            component: AppointmentHandlerComponent,
          },
          {
            path: 'first-nut-pathway',
            component: AppointmentHandlerComponent,
          },
        ],
      },
      {
        path: 'assistance-service',
        component: AssistanceServiceComponent,
        canActivate: [authGuard],
        canActivateChild: [authGuard],
      },
      {
        path: 'assistance-service/general',
        component: AssistanceFormComponent,
        canActivate: [authGuard],
        canActivateChild: [authGuard],
        data: { type: 'general' },
      },
      {
        path: 'assistance-service/covid',
        component: AssistanceFormComponent,
        canActivate: [authGuard],
        canActivateChild: [authGuard],
        data: { type: 'covid' },
      },
      {
        path: 'symptom-assessment',
        canActivate: [authGuard],
        canActivateChild: [authGuard],
        children: [
          {
            path: '',
            component: SymptomAssessmentComponent,
          },
          {
            path: 'symptom-assessment/:individualId/:consultDate',
            component: SymptomDetailsComponent,
          },
          {
            path: 'new-valutation',
            component: AppointmentHandlerComponent,
          },
        ],
      },
      {
        path: 'health-folder',
        component: HealthFolderComponent,
        canActivate: [authGuard],
        canActivateChild: [authGuard],
        children: [
          {
            path: '',
            redirectTo: 'medical-data',
            pathMatch: 'full',
          },
          {
            path: 'medical-data',
            component: MedicalDataComponent,
          },
          {
            path: 'medical-history',
            component: MedicalHistoryComponent,
          },
          {
            path: 'misuration',
            component: MisurationComponent,
          },
        ],
      },
      {
        path: 'health-folder/reports',
        component: ReportsPageComponent,
        canActivate: [authGuard],
        canActivateChild: [authGuard],
      },
      {
        path: 'health-folder/all-history',
        component: MedicalRecordRecapComponent,
        canActivate: [authGuard],
        canActivateChild: [authGuard],
      },
      {
        path: 'personal-area',
        component: PersonalAreaComponent,
        canActivate: [authGuard],
        canActivateChild: [authGuard],
        children: [
          {
            path: '',
            redirectTo: 'your-data',
            pathMatch: 'full',
          },
          { path: 'your-data', component: YourDataComponent },
          { path: 'profile-management', component: ProfileManagementComponent },
          { path: 'invoices-and-methods-payment', component: InvoicesMethodsPaymentComponent },
          { path: 'payment-details/:rateNumber', component: MedicalConsultationsDetailsComponent },
        ],
      },
      {
        path: 'who-we-are',
        component: WhoWeAreComponent,
        canActivate: [authGuard],
        canActivateChild: [authGuard],
      },
      {
        path: 'faq',
        component: FaqComponent,
        canActivate: [authGuard],
        canActivateChild: [authGuard],
      },
      {
        path: 'terms-of-use',
        component: TermsOfUseComponent,
        canActivate: [authGuard],
        canActivateChild: [authGuard],
      }
    ]
  }
];
